import { OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE } from 'Constants/'

import { zones } from 'Helpers/dates'
import { selector, selectorFamily } from 'recoil'

import { workflowCommonDataState, workflowDetails } from './data'

const extractHHmm = (strDate) => strDate.substring(11, 16)

const extractYmd = (strDate) => strDate.substring(0, 10)

const extractmd = (strDate) => strDate.substring(5, 10)

export const workflowSettingsState = selector({
  key: 'workflowSettingsState',
  get: ({ get }) => {
    const {
      Type,
      Group,
      Filter,
      FiltersRule,
      StartHour,
      BlackoutStartHour,
      BlackoutEndHour,
      TimeZoneCode,
      StartDate,
      EndDate,
      FrequencyBlackoutDate,
      NotInWeekends,
      FrequencySafeGuard
    } = get(workflowDetails)
    const { groups, filters } = get(workflowCommonDataState)
    //
    const includeGroups = Group.filter(({ Action }) => Action)
      .map(({ IdGroup }) => groups.find(({ value }) => value === IdGroup))
      .filter((o) => !!o)

    const excludeGroups = Group.filter(({ Action }) => !Action)
      .map(({ IdGroup }) => groups.find(({ value }) => value === IdGroup))
      .filter((o) => !!o)

    const applyFilters = Filter.map(({ IdFilter }) =>
      filters.find(({ value }) => value === IdFilter)
    ).filter((o) => !!o)

    const startHour = StartHour ? extractHHmm(StartHour) : undefined
    const blackoutStartHour = BlackoutStartHour
      ? extractHHmm(BlackoutStartHour)
      : undefined
    const blackoutEndHour = BlackoutEndHour
      ? extractHHmm(BlackoutEndHour)
      : undefined

    const tzlabel = TimeZoneCode ? zones[TimeZoneCode] : undefined
    const tzcodeui = TimeZoneCode
      ? TimeZoneCode.replace(/([^.]+)\.\d+$/, '$1')
      : undefined
    const tz = tzlabel ? `${tzcodeui} - ${tzlabel}` : undefined

    const startDate = StartDate ? extractYmd(StartDate) : undefined
    const endDate = EndDate ? extractYmd(EndDate) : undefined

    const freqBlackoutDays = Array.isArray(FrequencyBlackoutDate)
      ? FrequencyBlackoutDate.filter(({ Recurring }) => !Recurring).map(
          ({ Date }) => extractYmd(Date)
        )
      : []

    const freqBlackoutHours = Array.isArray(FrequencyBlackoutDate)
      ? FrequencyBlackoutDate.filter(({ Recurring }) => !!Recurring).map(
          ({ Date }) => extractmd(Date)
        )
      : []

    const hasFreqSafeGuard =
      Type === OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE

    //

    return {
      includeGroups,
      excludeGroups,
      applyFilters,
      applyFiltersRule: applyFilters.length > 1 ? FiltersRule : undefined,
      startHour,
      blackoutStartHour,
      blackoutEndHour,
      tz,
      startDate,
      endDate,
      freqBlackoutDays,
      freqBlackoutHours,
      notInWeekends: NotInWeekends,
      hasFreqSafeGuard,
      frequencySafeGuard: FrequencySafeGuard
    }
  }
})

export const workflowSettingsEmptyState = selector({
  key: 'workflowSettingsEmptyState',
  get: ({ get }) => {
    const {
      Type,
      Group,
      Filter,
      StartHour,
      TimeZoneCode,
      StartDate,
      EndDate,
      FrequencyBlackoutDate,
      NotInWeekends
    } = get(workflowDetails)

    return !(
      !!TimeZoneCode ||
      Group.length > 0 ||
      Filter.length > 0 ||
      !!StartHour ||
      !!StartDate ||
      !!EndDate ||
      FrequencyBlackoutDate.length > 0 ||
      NotInWeekends ||
      Type === OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE
    )
  }
})

export const workflowStepConditionDescriptionState = selectorFamily({
  key: 'workflowStepConditionDescriptionState',
  get:
    (idStep) =>
    ({ get }) => {
      const {
        conditionsDescription: { WaitStep }
      } = get(workflowCommonDataState)

      const match = WaitStep && WaitStep.find(({ IdStep }) => IdStep === idStep)

      return match ? match.Description : undefined
    }
})
